<form *ngIf="configForm" [formGroup]="configForm" (ngSubmit)="onSubmit(configForm)">
  <mat-card class="content-card">
    <mat-card-header>
      <mat-card-title>
        <h5>Email config</h5>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-slide-toggle formControlName="reminderDistributionEnabled">
        Reminder distribution enabled
      </mat-slide-toggle>
      <mat-slide-toggle formControlName="reportDistributionEnabled">
        Report distribution enabled
      </mat-slide-toggle>
      <mat-form-field>
        <input matInput placeholder="Max reminders per distribution" formControlName="maxRemindersPerDistribution">
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="From email" formControlName="fromEmail" email>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="From name" formControlName="fromName">
      </mat-form-field>
    </mat-card-content>
    <mat-card-actions align="end">
      <button mat-button type="submit" [disabled]="!configForm.valid || configForm.pristine">
        <mat-icon>done</mat-icon>
        <a>Save</a>
      </button>
    </mat-card-actions>
  </mat-card>
</form>